// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2390":"27111565","2737":"347289af","2994":"31d6cfe0","4437":"89e85c3a","6594":"6b4e703e","6718":"85f1c87b","8918":"300e036b"}[chunkId] + ".chunk.css";
};